import * as React from 'react';
import ListItem from '@material-ui/core/ListItem';

const CustomListItemLink = (props) => {
    return <ListItem button={true} component="button" {...props} />;
};

export { CustomListItemLink as ListItemLink };
